import React, {
  type FC,
  type PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';

import { Flex } from '@chakra-ui/react';

import { type UploadUrlPostResponse } from '@/services/api';

type NewCVAnalysisStep = 1 | 2 | 3;

type CVAnalysisLayoutContextValue = {
  file: UploadUrlPostResponse | null;
  setFile: React.Dispatch<React.SetStateAction<UploadUrlPostResponse | null>>;
  step: NewCVAnalysisStep;
  setStep: React.Dispatch<React.SetStateAction<NewCVAnalysisStep>>;
  email: string | undefined;
  setEmail: React.Dispatch<React.SetStateAction<string | undefined>>;
  name: string | undefined;
  setName: React.Dispatch<React.SetStateAction<string | undefined>>;
};

export const CVAnalysisContext =
  React.createContext<CVAnalysisLayoutContextValue | null>(null);

export const useCVAnalysisContextContext = () => {
  const ctx = useContext(CVAnalysisContext);
  if (ctx === null) {
    throw new Error('Missing parent <NewCVAnalysisLayoutContext> component');
  }
  return ctx;
};

export const NewCVAnalysisLayoutContext: FC<PropsWithChildren> = ({
  children,
}) => {
  const [step, setStep] = useState<NewCVAnalysisStep>(1);
  const [file, setFile] = useState<UploadUrlPostResponse | null>(null);
  const [email, setEmail] = useState<string>();
  const [name, setName] = useState<string>();

  const providerValue = useMemo(
    () => ({
      file,
      setFile,
      step,
      setStep,
      email,
      setEmail,
      name,
      setName,
    }),
    [file, step, email, name]
  );

  return (
    <CVAnalysisContext.Provider value={providerValue}>
      <Flex flex="1" direction="column">
        {children}
      </Flex>
    </CVAnalysisContext.Provider>
  );
};
